import { Injectable } from "@angular/core";
import { SharedService } from "@services/shared/shared.service";
import { ReplaySubject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class LoadingService {
  public loading$ = new ReplaySubject<boolean>(1);

  constructor(public shared: SharedService) {
    this.loading$.next(false);
  }
}
